<template>
  <slotted-edit-list-item :label="label"
                          :value="value && value[0] ? value : $t('servicesystem.common_objects.fallbackterms.none')"
                          :edit="edit">
    <template v-slot:normalmodecontent
              v-if="value && value[0]">
      <v-list-item-content class="py-0">
        <normal-mode-template :label="label">
          <template v-slot:value>
            <v-chip-group column
                          class="px-3">
              <user-chip v-for="(user, index) in value"
                         :key="user.User ? user.User.Id : user.Id"
                         :user="user.User ? user.User : user"
                         :index="index"
                         :typecolored="true">
              </user-chip>
            </v-chip-group>
          </template>
        </normal-mode-template>
      </v-list-item-content>
    </template>
    <template v-slot:editmodecontent>
      <v-card class="d-flex flex-column pb-3 my-3"
              id="imitation-border"
              width="100%"
              outlined>
        <v-list-item class="pa-0">
          <v-list-item-content class="py-0">
            <!------------------------------------------------------------------------------------            selected users template             -->
            <normal-mode-template :label="label"
                                  :value="editValue.length > 0 ? undefined : $t('servicesystem.common_objects.fallbackterms.none') ">
              <template v-slot:value
                        v-if="editValue.length > 0">
                <v-chip-group column
                              class="px-3">
                  <user-chip v-for="(user, index) in editValue"
                             :key="user.Id"
                             :user="user"
                             :index="index"
                             :closeable="'mdi-close'"
                             @Close="remove(user)"
                             :typecolored="true"
                             :nowave="true"
                             :color="user.new ? 'green' : undefined">
                  </user-chip>
                  <v-btn @click="removeAll"
                         icon>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-chip-group>
              </template>
            </normal-mode-template>
            <!-------------------------------------------------------------------------------------             removed users template               -->
            <normal-mode-template v-if="removed.length > 0"
                                  :label="removeditemslabel ? removeditemslabel : $t('servicesystem.common_objects.fallbackterms.removed')">
              <template v-slot:value>
                <v-chip-group column
                              class="px-3">
                  <template v-for="(user, index) in removed">
                    <user-chip :key="user.Id"
                               :user="user"
                               :index="index"
                               :closeable="'mdi-arrow-up'"
                               @Close="add(user)"
                               :typecolored="false"
                               :nowave="true"
                               :color="'red'">
                    </user-chip>
                  </template>
                  <v-btn v-if="removed.length > 0"
                         @click="addAll"
                         icon>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-chip-group>
              </template>
            </normal-mode-template>
          </v-list-item-content>
        </v-list-item>
        <!-------------------------------------------------------------------------------------            filter users template                   -->
        <v-autocomplete v-model="editValue"
                        :items="items"
                        dense
                        background-color="white"
                        filled
                        chips
                        :label="filterhint ? filterhint : 'Search'"
                        item-text="Name"
                        item-value="Id"
                        return-object
                        multiple
                        class="mx-3"
                        hide-details="auto">
          <template v-slot:selection></template>
          <template v-slot:item="{ active, item, attrs, on }">
            <v-list-item v-on="on"
                         v-bind="attrs"
                         @click="newmark(item)"
                         #default="{ active }">
              <v-list-item-action>
                <v-checkbox :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{item.Name}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-card>
    </template>
  </slotted-edit-list-item>
</template>


<script>
import SlottedEditListItem from "@/components/Inputs/Parts/SlottedEditListItem.vue";
import NormalModeTemplate from "@/components/Inputs/Parts/NormalModeTemplate.vue";
import UserChip from "@/components/Buttons/UserChip.vue";

export default {
  name: "UserList",
  props: ["label", "removeditemslabel", "filterhint", "items", "value", "edit", "keyname"],
  components: { SlottedEditListItem, NormalModeTemplate, UserChip },

  data() {
    return {
      editValue: [],
      newusers: [],
      removedusers: [],
    };
  },

  mounted() {
    
    this.editValue = Object.assign([], this.value);
  },

  methods: {
    add(item) {
      this.editValue.push(item);
    },

    addAll() {
      this.removed.forEach((item) => {
        this.editValue.push(item);
      });
    },

    remove(item) {
      this.editValue = this.editValue.filter(function (x) {
        return x.Id != item.Id;
      });
    },

    removeAll() {
      this.editValue = [];
    },

    newmark(item) {
      var isSelected = this.editValue.findIndex((x) => x.Id === item.Id) === -1;
      var wasRemoved = this.removed.findIndex((x) => x.Id === item.Id) != -1;
      
      
      item.new = isSelected && !wasRemoved ? true : undefined;
    },
  },

  computed: {
    removed() {
      const list = this.editValue;
      var filtered = this.value.filter(function (item) {
        return list.findIndex((x) => x.Id === item.Id) === -1;
      });
      
      
      return filtered;
    },
  },

  watch: {
    value: {
      deep: true,
      handler() {
        this.editValue = Object.assign([], this.value);
      },
    },
    'editValue.length'() {
      this.$emit("fetch", { key: this.keyname, value: this.editValue });
    },
  },
};
</script>

<style lang="scss" scoped>
#imitation-border {
  border: 1px solid rgb(175, 175, 175);
}
</style>